export default __webpack_public_path__ + "static/media/nft-of-the-day.ee094e75.svg";